import { tw } from '@/utils/tw';
import BaseArticleDateTheme from 'base/components/ArticleDate/theme';

const ArticleDate = tw.theme({
  extend: BaseArticleDateTheme,
  slots: {
    date: `text-gray-700 text-ui-md`,
    updatedDate: `text-gray-700 text-ui-md`,
  },
});

export default ArticleDate;
